import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TuiHintModule, TuiTextfieldControllerModule } from "@taiga-ui/core";
import {
  TuiInputTimeModule,
  TuiUnfinishedValidatorModule
} from "@taiga-ui/kit";
import { KwikUIInputTimeComponent } from "./input-time.component";

@NgModule({
  declarations: [KwikUIInputTimeComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TuiHintModule,
    TuiInputTimeModule,
    TuiTextfieldControllerModule,
    TuiUnfinishedValidatorModule
  ],
  exports: [KwikUIInputTimeComponent]
})
export class KwikUIInputTimeModule {}
